'use client';

import { StoryblokServerComponent } from '@storyblok/react/rsc';
import { FC } from 'react';
import { Container } from 'atoms/Container';
import { H1, H2, P } from 'atoms/Typography';
import { RichTextMarkdown } from 'pages/StoryBlok/RichText';
import { IStoryblokBannersTrustAll } from 'pages/StoryBlok/TrustBanner/types';
import { useStoryBlokBannerTileMediaQuery } from 'modules/mui/hooks';
import styles from './styles.module.css';

export const StoryblokBannersTrustAll: FC<IStoryblokBannersTrustAll> = ({
  banners,
  title,
  hideOn,
  deviceType,
}) => {
  return deviceType && Boolean(hideOn?.includes(deviceType)) ? null : (
    <Container>
      {!!title?.length && (
        <RichTextMarkdown
          text={title}
          components={{
            h1: ({ children }) => <H1 className={styles.h1}>{children}</H1>,
            h2: ({ children }) => <H2 className={styles.h2}>{children}</H2>,
            p: ({ children }) => <P className={styles.p}>{children}</P>,
          }}
        />
      )}
      <div className={styles.grid}>
        {banners?.map((nestedBlok) => (
          <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
        ))}
      </div>
    </Container>
  );
};

export const StoryblokBannersTrustAllWrapper: FC<IStoryblokBannersTrustAll> = ({
  banners,
  title,
  hideOn,
}) => {
  const deviceType = useStoryBlokBannerTileMediaQuery();

  return (
    <StoryblokBannersTrustAll
      banners={banners}
      title={title}
      hideOn={hideOn}
      deviceType={deviceType.type}
    />
  );
};
